import Work1 from "../../assets/work1.jpg";
import Work10 from "../../assets/work10.jpg";
import Work11 from "../../assets/work11.png";
import Work12 from "../../assets/work12.png";
import Work13 from "../../assets/work13.png";
import Work14 from "../../assets/work14.png";

export const projectsData = [
    {
        id: 14,
        image: Work14,
        title: "Alto Noa Shopping",
        category: "web",
        link: "https://altonoa.com.ar/",
        description: "Landing Page Alto Noa Shopping IRSA",
        tags: [],
    },
    {
        id: 1,
        image: Work1,
        title: "Tres Squash - Club de Squash",
        category: "web",
        link: "https://tressquash.com/",
        description: "Sistema de reservas y gestión",
        tags: [],
        // "bxl-css3", "bxl-javascript", "bxl-react", "bxl-typescript", "bxl-nodejs", "mysql"
    },
    {
        id: 11,
        image: Work11,
        title: "Interpres - Academia de Idiomas",
        category: "web",
        link: "https://www.idiomasinterpres.com/",
        description: "Landing Page + Elearning para academia de idiomas",
        tags: [],
        // "bxl-css3", "bxl-javascript", "bxl-react", "bxl-typescript", "bxl-nodejs"
    },
    {
        id: 12,
        image: Work12,
        title: "Biotec - Consulting Group",
        category: "web",
        link: "https://biotec.ar/home",
        description: "Página web corporativa para consulting group",
        tags: [],
        // "bxl-css3", "bxl-javascript", "bxl-react", "bxl-typescript", "bxl-nodejs"
    },
    {
        id: 13,
        image: Work13,
        title: "Amado, Adet, Rodríguez Berdier & Asociados",
        category: "web",
        link: "https://amadoabogados.com.ar/",
        description: "Landing Page informativa para Estudio de Abogados",
        tags: [],
        // "bxl-css3", "bxl-javascript", "bxl-react", "bxl-typescript", "bxl-nodejs"
    },
    {
        id: 10,
        image: Work10,
        title: "GLK - Minera en Salta",
        category: "web",
        link: "https://glk.com.ar/",
        description: "Página web corporativa para minera en Salta",
        tags: [],
        // "bxl-css3", "bxl-javascript", "bxl-react", "bxl-typescript", "bxl-nodejs"
    },
];